import axios from 'axios';
import { getCloudFunctionBase } from '@/config/deployment.js';

const HUBSPOT_CF_URL = getCloudFunctionBase() + '/cf-hubspot-center';
const CONTACTS_ENDPOINT = 'contacts';
const DEALS_ENDPOINT = 'deals';

const GENERIC_DEAL_NAME = 'Lead from /valuation';
const GENERIC_DEAL_STAGE = 'appointmentscheduled';

export async function createContact({ contactData, propertyData, client }) {
    return axios.post(`${HUBSPOT_CF_URL}/${CONTACTS_ENDPOINT}`, {
        email: contactData.email,
        relationshipType: contactData.relationshipType === 'tenant' ? 'Tenant' : 'Landlord',
        notes: {
            address: propertyData.address,
            rooms: Number(propertyData.nrOfRooms),
            area: Number(propertyData.apartmentArea),
            condition: propertyData.apartmentCondition,
            floor_nr: Number(propertyData.apartmentFloor),
            nr_of_floors: Number(propertyData.nrOfFloors),
            balcony: Boolean(propertyData.balcony),
            parking: Boolean(propertyData.parking),
            client: client
        }
    });
}

export function createDeal({ hubspotContactId }) {
    return axios.post(`${HUBSPOT_CF_URL}/${DEALS_ENDPOINT}`, {
        dealname: GENERIC_DEAL_NAME,
        dealstage: GENERIC_DEAL_STAGE,
        contactId: hubspotContactId,
    });
}


// WEBPACK FOOTER //
// ./src/services/hubspot/index.js